export default "__VITE_ASSET__3fcade98__"